import { render, staticRenderFns } from "./GameInformation.vue?vue&type=template&id=442e7c48&"
import script from "./GameInformation.vue?vue&type=script&lang=js&"
export * from "./GameInformation.vue?vue&type=script&lang=js&"
import style0 from "./GameInformation.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports